import { Node, mergeAttributes } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    mermaidBlock: {
      insertMermaidBlock: (code: string) => ReturnType;
    };
  }
}

export const MermaidBlockNode = Node.create({
  name: 'mermaidBlock',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      code: {
        default: 'graph LR\n    A --> B',
        parseHTML: (el) => el.getAttribute('data-code') || '',
        renderHTML: (attrs) => ({ 'data-code': attrs['code'] }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-mermaid]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-mermaid': 'true',
        class: 'mermaid-block',
        style: 'background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 4px; padding: 1em; margin: 1em 0;',
      }),
      [
        'pre',
        {
          class: 'mermaid-code',
          style: 'font-family: monospace; font-size: 0.875em; color: #495057; margin: 0;',
        },
        node.attrs['code'] as string,
      ],
    ];
  },

  addCommands() {
    return {
      insertMermaidBlock:
        (code: string) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { code },
          });
        },
    };
  },
});
